import axios from 'axios';
import {
  SearchApiResponse,
  SearchElasticsearchResponse,
  SearchQueryParams,
} from 'types/search';
import { SEARCH_API } from '../config/constants';

const { get } = axios;

/**
 * Runs a content search against the OLE search API.
 * @returns The Elasticsearch `response` object from the API payload.
 */
export const search = async (
  query: SearchQueryParams,
): Promise<SearchElasticsearchResponse> => {
  const { data } = await get<SearchApiResponse>(SEARCH_API, {
    params: query,
  });
  return data.response;
};

export default search;
